import { WrappedRandom } from "./wrapped.js";
const SYSTEM = new WrappedRandom(Math.random);
export {
  SYSTEM
};
